import { css } from '@emotion/react';
import { p2r } from '../../styles/fonts';

const styles = css`
  .poll-container .opinary-iframe {
    width: 100%;
    height: 100%;
    min-height: ${p2r(600)};
  }
`;

export default styles;
